import React, {useState} from 'react';

const RankingsAndLevelsMapContext = React.createContext({});

// @ts-ignore
const RankingsAndLevelsMapProvider = ({ children }) => {
    const [country, setCountry] = useState<string | null>(null);

    return (
        <RankingsAndLevelsMapContext.Provider value={{country, setCountry}} >
            {children}
        </RankingsAndLevelsMapContext.Provider>
    );
};

export {
    RankingsAndLevelsMapProvider,
    RankingsAndLevelsMapContext,
}
